import PhonelinkSetupOutlinedIcon from '@mui/icons-material/PhonelinkSetupOutlined';
import { Button, Tooltip } from '@mui/material';

/**
 * Baixar os assets do aplicativo a partir do modelo escolhido.
 *
 * Ainda SEM FUNÇÃO — o botão existe para marcar o lugar do passo que fecha o
 * ciclo (a pasta `wl-src/<release>/` com `chain-background.png` e
 * `chain-header-background.png` no tamanho de produção). Hoje esses arquivos
 * só existem em `out/` na máquina de quem rodou o gerador: o que sobe para o
 * bucket é a folha de mockup, que serve para escolher, não para o build.
 *
 * Fazer funcionar significa o gerador subir também os artboards da rodada, ou
 * a API rasterizar a partir do modelo escolhido — decisão que ainda não foi
 * tomada. Até lá o botão fica desabilitado e diz por quê, em vez de sumir e
 * deixar a pergunta "e como eu pego os assets?" sem resposta na tela.
 */
const DownloadAssetsButton = () => (
  <Tooltip title="Em breve: baixa chain-background.png e chain-header-background.png do modelo escolhido, no tamanho que o build do app espera. Por enquanto os assets saem da pasta out/ do gerador.">
    <span>
      <Button size="small" variant="outlined" startIcon={<PhonelinkSetupOutlinedIcon />} disabled>
        Baixar assets do app
      </Button>
    </span>
  </Tooltip>
);

export default DownloadAssetsButton;
